import React from 'react';
import { IconWrapper, TextArea, Title, Wrapper } from './styled';
import { useLocale } from 'locale';
import OkIcon from 'assets/svg/success-ic-v2.svg';
import { ModalWrapper } from 'components/tranzila-hosted-fields/modals/Wrapper';
import { AfterDeleteListingModalState } from 'store/state/app';
import { Button } from 'ds/components/button';


export const AfterDeleteListingModalBase: React.FC<{ isOpen: AfterDeleteListingModalState; setOpen: (modalState: AfterDeleteListingModalState) => void }> = ({ isOpen, setOpen }) => {
  const { t } = useLocale();

  if (!isOpen) return null;

  const handleOpen = () => setOpen(false);

  return (
    <ModalWrapper isOpen={true} onClose={handleOpen}>
      <Wrapper>
        <IconWrapper>
          <OkIcon />
        </IconWrapper>
        <Title>{t('after.listing.delete.modal.title')}</Title>
        <TextArea>{t('after.listing.delete.modal.text')}</TextArea>
        <Button size="extraLarge" onClick={handleOpen}>{t('manageBulletinPage.bulletin.cancelSubscriptionSuccessModal.confirm')}</Button>
      </Wrapper>
    </ModalWrapper>
  );
};
